import angular from 'angular';
// import _ from "lodash";

const PollingServiceFactory =  function PollingServiceFactory($log, $interval) {
        "ngInject";
        const DEFAULT_POLLING_TIME = 5*60*1000;
        let polls = {};

        const serviceObj = {

            /**
             * startPolling - crea un poller con un nome assegnatogli
             *
             * @param  {string} [M] name
             * @param  {type} [M] promiseFactoryfunction
             * @param  {type} [O] params
             * @param  {type} [M] pollingTime  - in millisecondi
             * @param  {type} [O] callback
             * @param  {type} [O] errorCallback
             * @return
             */
            startPolling: function(name, promiseFactoryfunction, params, pollingTime, callback, errorCallback) {
                if(name === undefined || typeof name !== "string"){
                  $log.error(`PollerService`,`startPolling`, `invalid name: ${name}`);
                }
                $log.debug('starting poll', name);
                // Check to make sure poller doesn't already exist
                if (!polls[name]) {
                    const poller = function() {
                        const promise = promiseFactoryfunction(params);
                        promise.then(function(result) {
                            if (callback !== undefined) {
                                callback(result);
                            } else {
                                this.stopPolling(name);
                            }
                        }, function(error) {
                            if (angular.isFunction(errorCallback)) {
                              // this.stopPolling(name);
                                errorCallback(error);
                            }
                        });

                    };
                    poller();
                    polls[name] = $interval(poller, pollingTime || DEFAULT_POLLING_TIME);
                } else {
                  $log.warn(`PollerService`,`startPolling`, `Poller with name ${name} already exists`);
                }
            },


            /**
             * stopPolling - distrugge il poller con il nome corrispondente
             *
             * @param  {String} name
             * @return
             */
            stopPolling: function(name) {
                $log.debug('stopping poll', name);
                if (angular.isDefined(polls[name])) {
                    $interval.cancel(polls[name]);
                    delete polls[name];
                }
            }
        };
        return serviceObj;
    }
export default PollingServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/polling.factory.js
 **/